let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eXPra")).then(() => parcelRequire('8nMC7'));